/** Shared fetch-button error messaging for mounting field configs. */
export function getMountingFetchErrorMessage(
  error: unknown,
  fetchConfiguration?: {
    timeoutErrorMessage?: string
    resolveFetchErrorMessage?: (error: unknown) => string | undefined
  }
): string {
  const resolved = fetchConfiguration?.resolveFetchErrorMessage?.(error)
  if (resolved) return resolved
  return fetchConfiguration?.timeoutErrorMessage || 'Data fetch timed out. Please try again.'
}
